import {
	getProductAccessStatusName,
	getProductNameOrNotAvailable,
} from 'domain/product/enums';
import { ProductRegistration } from 'domain/product/interfaces';

export const mapProductRegistrations = (
	productRegistrations: ProductRegistration[],
): ProductRegistration[] =>
	productRegistrations.map((productRegistration) => ({
		...productRegistration,
		name: getProductNameOrNotAvailable(productRegistration.productName),
		statusName: getProductAccessStatusName(
			productRegistration.accessStatus,
		),
	}));
